import { NgClass } from '@angular/common';
import { Component, computed, HostBinding, inject, input, viewChild } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { IconComponent } from '../../../icons/icon/icon.component';
import { Icon, SvgCacheService } from '../../../icons/icon/svg-cache.service';
import { FormFieldAddon, FormFieldAddonItem } from '../../form-field.interface';

@Component({
  selector: 'ui-form-field-addon-details',
  templateUrl: './form-field-addon-details.component.html',
  styleUrls: ['./form-field-addon-details.component.scss'],
  standalone: true,
  imports: [IconComponent, MatMenuModule, NgClass],
})
export class FormFieldAddonDetailsComponent {
  readonly addon = input<FormFieldAddon>();
  readonly position = input<'start' | 'end'>('start');
  readonly role = input<'inner' | 'outer'>('inner');

  readonly svgCacheService = inject(SvgCacheService);

  readonly menuTrigger = viewChild<MatMenuTrigger>(MatMenuTrigger);

  @HostBinding('class') get class() {
    return [
      this.role() === 'inner' ? 'inner-addon-content' : 'outer-addon-content',
      this.position() === 'start' ? 'addon-position-start' : 'addon-position-end',
      this.list()?.disabled ? 'form-field-addon-disabled' : '',
    ];
  }

  readonly icon = computed(() => {
    const addon = this.addon();
    if (!addon || typeof addon !== 'string' || !this.svgCacheService.isIcon(addon)) return;
    return addon as Icon;
  });

  readonly text = computed(() => {
    const addon = this.addon();
    if (!addon || typeof addon !== 'string' || this.svgCacheService.isIcon(addon)) return;
    return addon as string;
  });

  readonly list = computed(() => {
    const addon = this.addon();
    if (!addon || typeof addon === 'string' || addon.type !== 'list' || addon.items.length === 0) return;
    return addon;
  });

  readonly selectedItem = computed(() => {
    if (!this.list()) return;
    return this.list()?.items.find((item) => item.value === this.list()?.selectedValue) || this.list()?.items[0];
  });

  openMenu(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    this.menuTrigger()?.openMenu();
  }

  itemClicked(event: Event, item: FormFieldAddonItem) {
    event.preventDefault();
    event.stopPropagation();

    this.list()?.onChange(item.value);
  }
}
